import { type InsuranceType } from '#app/components/insurance-section.tsx'

export const insuranceTabs = [
	{
		id: 'personas',
		label: 'Personas',
		iconName: 'user-full-view',
		insurances: [
			{
				id: 'auto',
				title: 'Auto',
				iconName: 'car-04',
				color: 'blue' as const,
				link: '/cotizasimple-auto',
			},
			{
				id: 'caucion',
				title: 'Caución General',
				iconName: 'document-validation',
				color: 'blue' as const,
				link: '/cotizacion-caucion-general',
			},
			{
				id: 'caucion-alquiler',
				title: 'Caución Alquiler',
				iconName: 'house-02',
				color: 'blue' as const,
				link: '/cotizacion-caucion-alquiler',
			},
			{
				id: 'moto',
				title: 'Moto',
				iconName: 'motorbike-02',
				color: 'blue' as const,
				link: '/cotizacion-general?tipo=Moto',
			},
			{
				id: 'hogar',
				title: 'Hogar',
				iconName: 'house-02',
				color: 'blue' as const,
				link: '/cotizacion-general?tipo=Hogar',
			},
			{
				id: 'accidentes-personales',
				title: 'Accidentes personales',
				iconName: 'user-shield-01',
				color: 'blue' as const,
				link: '/cotizacion-general?tipo=Accidentes%20Personales',
			},
			// {
			// 	id: 'vida-retiro',
			// 	title: 'Vida y retiro',
			// 	iconName: 'user-sharing',
			// 	color: 'blue' as const,
			// },
			// {
			// 	id: 'integral-comercio',
			// 	title: 'Integral de comercio',
			// 	iconName: 'check',
			// 	color: 'blue' as const,
			// },
		] as InsuranceType[],
	},
	{
		id: 'empresas',
		label: 'Empresas',
		iconName: 'factory-02',
		insurances: [
			{
				id: 'art',
				title: 'ART',
				iconName: 'labor',
				color: 'green' as const,
				link: '/cotizacion-art',
			},
			{
				id: 'responsabilidad-civil',
				title: 'Responsabilidad Civil',
				iconName: 'user-shield-01',
				color: 'green' as const,
				link: '/cotizacion-rc-productos',
			},
			{
				id: 'responsabilidad-civil',
				title: 'RC Productos',
				iconName: 'safe',
				color: 'green' as const,
				link: '/cotizacion-rc-productos',
			},
			{
				id: 'rc-contratistas',
				title: 'RC Contratistas',
				iconName: 'labor',
				color: 'green' as const,
				link: '/cotizacion-rc-contratistas',
			},
			{
				id: 'agro',
				title: 'Integral Agropecuario',
				iconName: 'tractor',
				color: 'green' as const,
				link: '/cotizacion-integral-agropecuario',
			},
			// {
			// 	id: 'patrimonial',
			// 	title: 'Patrimonial',
			// 	iconName: 'house-02',
			// 	color: 'green' as const,
			// },
			// {
			// 	id: 'transporte',
			// 	title: 'Transporte',
			// 	iconName: 'car-04',
			// 	color: 'green' as const,
			// },
			// {
			// 	id: 'cyber',
			// 	title: 'Cyber',
			// 	iconName: 'laptop',
			// 	color: 'green' as const,
			// },
			// {
			// 	id: 'directivos',
			// 	title: 'Directivos',
			// 	iconName: 'user-shield-01',
			// 	color: 'green' as const,
			// },
			// {
			// 	id: 'grupo',
			// 	title: 'Grupo',
			// 	iconName: 'user-sharing',
			// 	color: 'green' as const,
			// },
		] as InsuranceType[],
	},
]
